export const blackbook =
  'M219 52.36v191.28a4.76 4.76 0 01-4.87 4.86H73.72C53 250.77 35 232.29 36 212.45V28.07C37.2 15.19 47.41 5 61.11 5.5h134.51c3.91.62 2.23 4.83 0 5H62c-26.74-3.59-25.28 38.41 0 37h79.1c10.8-5.93 2.39 124.61 4.9 126.48l18.38-18.14L183 174V52.34a4.64 4.64 0 00-4.9-4.84h36q4.9.24 4.9 4.86z'
